import React from 'react';
import { Container } from "./styles";

const Error = () => {
    return (
        <Container>
            <h2>404</h2>
            <p>Page not Found</p>
        </Container>
    )
}

export default Error;
